import React from 'react'

import classNames from 'classnames'

type TagProps = {
  name: string
  clickHandler: () => void
  className?: string
}

const Tag: React.FC<TagProps> = ({ name, clickHandler, className }) => (
  <div
    className={classNames(
      'flex items-center py-2 px-2.5 not-last:mr-2 text-md rounded-sm bg-gray-tabs dark:bg-gray-tabs-dm w-fit flex-nowrap',
      className
    )}>
    <p className="pr-2 text-black dark:text-gray whitespace-nowrap">{name}</p>
    <button className="cursor-pointer hover:opacity-50 nf-icon nf-close" onClick={clickHandler} />
  </div>
)

export default Tag
